import { useState } from 'react';

import { AmazonLink } from '../amazon-link/amazon-link';
import { Button } from '../button/button';
import { closedMessage } from '../../config';
import { CourseList } from '../course-list/course-list';
import { Modal } from '../modal/modal';
import { toTitleCase } from '../../utils';
import type { School } from '../../types';

import styles from './school.module.css';

type Props = {
  school: School;
};

export function School(props: Props) {
  const { school } = props;
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    document.body.classList.add('modal-open');
    setModalOpen(true);
  };

  const closeModal = () => {
    document.body.classList.remove('modal-open');
    setModalOpen(false);
  };

  const { courses = [] } = school;

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <h1 className={styles.titlejp}>{school.nameJp}</h1>
        <h2 className={styles.title}>{toTitleCase(school.name)}</h2>
      </header>

      {school.isClosed && (
        <div className={styles.closed}>
          <span>{closedMessage}</span>
        </div>
      )}

      <div className={styles.card}>
        <section className={styles.section}>
          <div className={styles.item}>
            <label className={styles.label}>Address</label>
            <div className={styles.value}>{school.address}</div>
          </div>
          <section className={styles.section}>
            <a href={`https://maps.google.com/?q=${school.address}`} target="_blank" rel="noopener noreferrer">
              <img
                className={styles.map}
                alt={school.address}
                src={`https://maps.googleapis.com/maps/api/staticmap?center=${school.address}&zoom=14&markers=${school.address}&size=700x400&scale=1&maptype=roadmap&key=AIzaSyBGAfSPvF4KjqvfxdGunEeP7k89Ja95aVk`}
              />
            </a>
          </section>

          <div className={styles.item}>
            <label className={styles.label}>Student capacity</label>
            <div className={styles.value}>{school.studentCapacity}</div>
          </div>

          <div className={styles.item}>
            <label className={styles.label}>Phone</label>
            <div className={styles.value}>{school.phone}</div>
          </div>

          <div className={styles.item}>
            <label className={styles.label}>Site</label>
            <div className={styles.value}>
              <a rel="noopener noreferrer" target="_blank" href={school.url + (school.url.endsWith('/') ? '' : '/')}>
                {school.url}
              </a>
            </div>
          </div>

          {school.principal && (
            <div className={styles.item}>
              <label className={styles.label}>Principal</label>
              <div className={styles.value}>{school.principal}</div>
            </div>
          )}
        </section>

        <section className={styles.section}>
          {school.courses && school.courses.length > 0 && (
            <div className={styles.item}>
              <label className={styles.label}>Admissions</label>
              <CourseList courses={courses} />
            </div>
          )}

          <div className={styles.item}>
            <label className={styles.label}>Additional notes</label>
            {school.description && <div className={styles.value}>{school.description}</div>}
          </div>

          <div className={styles.item}>
            <label className={styles.label}>Nearest station</label>
            <div className={styles.value}>{school.nearestStation}</div>
          </div>

          <div className={styles.item}>
            <label className={styles.label}>Accomdation available</label>
            <div className={styles.value}>{school.accomodation}</div>
          </div>

          {school.requirementsForAdmission && (
            <div className={styles.item}>
              <label className={styles.label}>Requirements for admission</label>
              <div className={styles.value}>{school.requirementsForAdmission}</div>
            </div>
          )}

          {school.selectionOfStudents && (
            <div className={styles.item}>
              <label className={styles.label}>Selection of students</label>
              <div className={styles.value}>{school.selectionOfStudents}</div>
            </div>
          )}
        </section>

        <section className={styles.section}>
          <Button onClick={openModal}>Learn Japanese online</Button>
          {modalOpen && <Modal closeModal={closeModal} />}
        </section>
      </div>
    </div>
  );
}
